import { createFileRoute } from '@tanstack/react-router';
import { AppLayout } from '@/layouts/AppLayout';
import { EntryPage } from '@/features/entry/pages';
import { McpOAuthFlow } from '@/features/mcp/McpOAuthFlow';
import { requireAuth } from '@/utils/authGuard';
import { isMcpOAuthFlow } from '@/utils/mcpOAuth';

function EntryRouteComponent() {
  if (typeof window !== 'undefined' && isMcpOAuthFlow(window.location.pathname, window.location.search)) {
    return <McpOAuthFlow />;
  }
  return (
    <AppLayout>
      <EntryPage />
    </AppLayout>
  );
}

export const Route = createFileRoute('/entry')({
  beforeLoad: requireAuth,
  component: EntryRouteComponent,
});
